// src/hooks/programs/useDeleteProgram.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteProgram } from "../../api/apiPrograms";
import parseError from "../../utils/parseError";

const useDeleteProgram = () => {
    const queryClient = useQueryClient();

    const {
        mutate: deleteProgramMutate,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: deleteProgram,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["programs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete program");
        },
    });

    return {
        deleteProgramMutate,
        isPending: isPending || isLoading,
    };
};

export default useDeleteProgram;
